/**
 * Shared - Error State
 *
 * Component for displaying when a page/feature encounters an error
 */

import { Icon, Card, CardBody, Button } from '@repo/ui';
import type { IconName } from '@repo/ui';

export interface ErrorStateProps {
  /** Icon name to display */
  icon: IconName;
  /** Title of the error state */
  title: string;
  /** Description text */
  description: string;
  /** Additional help text */
  helpText?: string;
  /** Retry callback function */
  onRetry?: () => void;
}

export function ErrorState({ icon, title, description, helpText, onRetry }: ErrorStateProps) {
  return (
    <Card variant="outlined" padding="lg">
      <CardBody className="text-center py-12">
        <Icon name={icon} className="h-16 w-16 text-red-500 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-xtnd-dark dark:text-xtnd-white mb-2">{title}</h2>
        <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto">{description}</p>
        {helpText && <p className="text-sm text-gray-500 dark:text-gray-500 mb-6">{helpText}</p>}
        {onRetry ? (
          <Button
            onClick={onRetry}
            variant="primary"
            leftIcon={<Icon name="HiRefresh" className="h-4 w-4" />}
          >
            Retry
          </Button>
        ) : null}
      </CardBody>
    </Card>
  );
}
